"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Header = _interopRequireDefault(require("../Header"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LackingPermissions = function LackingPermissions(_ref) {
  var customSwitchProject = _ref.customSwitchProject,
    hideProjectDropdown = _ref.hideProjectDropdown,
    isExported = _ref.isExported,
    labelForProject = _ref.labelForProject,
    labelForProjectPlural = _ref.labelForProjectPlural,
    limitProjectsByPermissions = _ref.limitProjectsByPermissions,
    projectIdWhitelist = _ref.projectIdWhitelist,
    regardlessOfProject = _ref.regardlessOfProject;
  var header = hideProjectDropdown ? null : /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    customSwitchProject: customSwitchProject,
    isExported: isExported,
    labelForProject: labelForProject,
    labelForProjectPlural: labelForProjectPlural,
    limitProjectsByPermissions: limitProjectsByPermissions,
    projectIdWhitelist: projectIdWhitelist,
    showProjectDropdown: true,
    showQuestCount: false
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, header, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].info
  }, /*#__PURE__*/_react["default"].createElement("h3", null, "You lack permission to view this area", regardlessOfProject ? '' : ' in this project', "."), /*#__PURE__*/_react["default"].createElement("p", null, "If you believe that you have received this message in error, please contact your administrator.")));
};
LackingPermissions.propTypes = {
  customSwitchProject: _propTypes["default"].func,
  hideProjectDropdown: _propTypes["default"].bool,
  isExported: _propTypes["default"].bool,
  labelForProject: _propTypes["default"].string,
  labelForProjectPlural: _propTypes["default"].string,
  limitProjectsByPermissions: _propTypes["default"].array,
  projectIdWhitelist: _propTypes["default"].array,
  regardlessOfProject: _propTypes["default"].bool
};
var _default = exports["default"] = LackingPermissions;